module.exports = __webpack_public_path__ + "img/9yy03c9cb2ba0b92e339671aa132f6e8.c6a2eed3.png";